module.exports = __webpack_public_path__ + "img/51.fe3c96e5.png";